import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "sb_pwa_dismissed_at";
const DISMISS_MS = 1000 * 60 * 60 * 24 * 7; // 7 days

export default function InstallPWA() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const dismissedAt = Number(localStorage.getItem(DISMISS_KEY) || 0);
    const recentlyDismissed = dismissedAt && Date.now() - dismissedAt < DISMISS_MS;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      if (!recentlyDismissed) setVisible(true);
    };
    const onInstalled = () => {
      setInstalled(true);
      setVisible(false);
      setDeferred(null);
    };

    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome !== "accepted") {
      localStorage.setItem(DISMISS_KEY, String(Date.now()));
    }
    setVisible(false);
    setDeferred(null);
  };

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  if (installed || !visible || !deferred) return null;

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[min(92vw,420px)] rounded-2xl border border-[#E2DCD0] bg-white/95 backdrop-blur-xl shadow-2xl p-4 flex items-center gap-3 animate-in fade-in slide-in-from-bottom-4"
    >
      <div className="w-11 h-11 rounded-xl bg-[#E25A24] grid place-items-center text-white font-serif text-2xl shrink-0">स</div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-[#13294B] leading-tight">Install Swadeshi Bazaar</div>
        <div className="text-xs text-[#4A5568] mt-0.5">Add to your home screen for quick access.</div>
      </div>
      <button
        data-testid="pwa-install-btn"
        onClick={install}
        className="shrink-0 inline-flex items-center gap-1.5 px-3 py-2 rounded-full bg-[#13294B] text-white text-xs font-semibold hover:bg-[#0D141C] transition-colors"
      >
        <Download className="w-3.5 h-3.5" /> Install
      </button>
      <button
        data-testid="pwa-dismiss-btn"
        onClick={dismiss}
        aria-label="Dismiss install prompt"
        className="shrink-0 p-1.5 rounded-full hover:bg-[#F2EFEB] text-[#718096]"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
